import ActionsMobile from './ActionsMobile';

export default ActionsMobile;
export { ActionsMobile };
